import { graphql } from 'src/gql';

export const adPerformanceReportQuery = graphql(`
  query GetAdPerformanceReport($input: AdPerformanceReportWidgetInput!) {
    analyticsAdPerformanceReport(input: $input) {
      success
    }
  }
`);
